import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
	selector: 'app-kiosk-label-quantity',
	templateUrl: './kiosk-label-quantity.component.html',
	styleUrls: ['./kiosk-label-quantity.component.scss'],
})
export class KioskLabelQuantityComponent {
	@Input() item: string;
	@Output() SelectQuantity = new EventEmitter<string>();

	// biome-ignore lint/complexity/noUselessConstructor: <explanation>
	constructor() {}

	select(event: Event) {
		const button = event.target as HTMLButtonElement;
		const buttonText = button.textContent || button.innerText;

		this.SelectQuantity.emit(buttonText);
	}
}
